import { api } from './api';
import { fetchResource } from './fetchResource';

export function fetchIncomes() {
  return dispatch => {
    fetchResource(dispatch, 'annuities', 'ANNUITIES_FETCHED');
    fetchResource(dispatch, 'trust_funds', 'TRUST_FUNDS_FETCHED');
    fetchResource(dispatch, 'unclassified_incomes', 'UNCLASSIFIED_INCOMES_FETCHED');
    fetchResource(dispatch, 'pensions', 'PENSIONS_FETCHED');
  };
}

export function updateIncomes(incomes) {
  return dispatch => {
    return api.put('/api/fixed_incomes', incomes);
  };
}
